import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { getVendorName } from "../../../utils/getVendorName";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useFetchMonthWisePointsMutation, } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";
import toast from "react-hot-toast";
import { formatter } from "../../../utils/numberFormatter";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";

function getToolTipMessage(type) {
    const tooltipMap = new Map([
        [
            "Points Earned",
            "This is the earned points(90%) of user in that month (No extra points included) .",
        ],
        [
            "Points Reserved",
            "This is the reserved points(10%) of user in that month (No extra points included) .",
        ],
        [
            "Total Extra Points",
            "This is the total extra points (50K Bonus and 1K Bonus) of user in that month.",
        ],
    ]);

    return tooltipMap.get(type) || "";
}


const MonthWisePointSummary = () => {
    const [
        fetchMonthWisePoints,
        {
            data: monthWisePointsData,
            isLoading: monthWisePointsIsLoading,
            error: monthWisePointsError,
        },
    ] = useFetchMonthWisePointsMutation();

    const [
        fetchMonthWisePointsCsv,
        {
            data: monthWisePointsCsvData,
            isLoading: monthWisePointsCsvIsLoading,
            error: monthWisePointsCsvError,
        },
    ] = useFetchMonthWisePointsMutation();

    const navigate = useNavigate();

    const [totalRows, setTotalRows] = useState(0);
    const [data, setData] = useState([])

    const [viewPointsSummaryToggle, setViewPointsSummaryToggle] = useState(false);
    const [pointsData, setPointsData] = useState(null);


    const [csvData, setCsvData] = useState(null);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const initialRequest = {
        mobile: "",
        startDate: "",
        endDate: "",
        startMonth: null,
        startYear: null,
        endMonth: null,
        endYear: null,
        limit: limit,
        offset: offset
    };

    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
    };

    const fetchAllPointsSummaryFunc = () => {
        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchMonthWisePoints({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            queryParams: queryParams
        });
    };


    const handlefetchAllPointsSummaryCsvFunc = () => {

        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        updatedRequest.limit = 10000;
        updatedRequest.offset = 0;

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchMonthWisePointsCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            queryParams: queryParams
        });
    }

    useEffect(() => {
        // if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id != 38 || ) {
        //     navigate(`/genefied/${getVendorName()}/`);

        // }
        fetchAllPointsSummaryFunc();
    }, [request, limit, offset]);


    useEffect(() => {
        if (monthWisePointsData && monthWisePointsData.body) {
            console.log("monthWisePointsData", monthWisePointsData);
            setData(monthWisePointsData.body?.data ?? []);
            setTotalRows(monthWisePointsData.body?.total_records ?? 0)
        }

        if (monthWisePointsError && monthWisePointsError?.data) {
            if (monthWisePointsError.status != 500) {
                toast.error(`${monthWisePointsError?.data?.message}`, { id: "monthWisePointsError" })
            } else {
                toast.error("Something went wrong", { id: "monthWisePointsError" })
            }
            console.log("monthWisePointsError ", monthWisePointsError);
        }
    }, [monthWisePointsData, monthWisePointsError]);


    useEffect(() => {
        if (monthWisePointsCsvData && monthWisePointsCsvData.body) {
            console.log("monthWisePointsCsvData", monthWisePointsCsvData);
            setCsvData(monthWisePointsCsvData?.body?.data);
        }

        if (monthWisePointsCsvError) {
            if (monthWisePointsCsvError.status != 500) {
                toast.error(`${monthWisePointsCsvError?.data?.message}`, { id: "monthWisePointsCsvError" })
            } else {
                toast.error("Something went wrong", { id: "monthWisePointsCsvError" })
            }
            console.log("monthWisePointsCsvError ", monthWisePointsCsvError);
        }
    }, [monthWisePointsCsvData, monthWisePointsCsvError]);


    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Mobile",
            selector: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "User ID",
            selector: (row) => row.user_id,
            sortable: true,
            width: "150px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "220px",
        },
        {
            name: "Month",
            selector: (row) => row.month,
            sortable: true,
            width: "100px",
        },
        {
            name: "Year",
            selector: (row) => row.year,
            sortable: true,
            width: "100px",
        },
        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Points Earned
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Points Earned")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.points_earned,
            cell: (row) => <span>{formatter.format(row.points_earned)}</span>,
            sortable: true,
            width: "220px",
        },
        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Points Reserved
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Points Reserved")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.points_reserved,
            cell: (row) => <span>{formatter.format(row.points_reserved)}</span>,
            sortable: true,
            width: "220px",
        },

        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Total Extra Points
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Total Extra Points")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.extra_points,
            cell: (row) => <span>{formatter.format(row.extra_points)}</span>,
            sortable: true,
            width: "220px",
        },


    ];



    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Month Wise Points
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        <div className="mb-2">
                            <CustomExport fetchData={handlefetchAllPointsSummaryCsvFunc}
                                data={csvData}
                                defaultColumnExport={[
                                    "name",
                                    "mobile",
                                    "user_id",
                                    "month",
                                    "year",
                                    "points_earned",
                                    "points_reserved",
                                    "extra_points",
                                ]}
                                filename="userPointSummary"
                            />
                        </div>
                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                // title={"Product List"}
                                data={data}
                                loading={monthWisePointsIsLoading}
                                totalRows={totalRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            >
                                <div className="border-b pb-3 border-gray-300 bg-gray-50 rounded-t-lg">
                                    <div className="flex  space-x-2 justify-end">
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Mobile
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Mobile..."
                                                    required
                                                    value={request.mobile}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => {
                                                            return { ...prevState, mobile: newValue };
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Name
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Name..."
                                                    required
                                                    value={request.name}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => {
                                                            return { ...prevState, name: newValue };
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Start Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">Start Month</label>
                                                <input
                                                    type="month"
                                                    value={request.startDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({ ...prev, startDate: e.target.value }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>

                                        {/* End Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">End Month</label>
                                                <input
                                                    type="month"
                                                    value={request.endDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({ ...prev, endDate: e.target.value }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>


                                        <div className="flex flex-row  gap-2 h-10">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right  p-2"
                                                    onClick={() => {
                                                        fetchAllPointsSummaryFunc();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right p-2"
                                                    onClick={() => {
                                                        clearFilters();
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DataTableComponent>

                        </div>

                        {viewPointsSummaryToggle && (
                            <ModalComponent
                                size="xl"
                                show={viewPointsSummaryToggle}
                                setShow={setViewPointsSummaryToggle}
                            >
                                <div className="w-full">
                                    <div className="w-full p-4">
                                        <h2 className="text-lg font-semibold mb-4">Monthly Point Summary</h2>
                                        {Array.isArray(pointsData?.month_wise_data) && pointsData?.month_wise_data.length > 0 ? (
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full table-auto border border-gray-300 text-sm">
                                                    <thead className="bg-gray-100">
                                                        <tr>
                                                            <th className="border px-4 py-2 text-left">Month</th>
                                                            <th className="border px-4 py-2 text-left">Year</th>
                                                            <th className="border px-4 py-2 text-left">Points Earned</th>
                                                            <th className="border px-4 py-2 text-left">Points Reserved</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pointsData?.month_wise_data.map((item, index) => (
                                                            <tr key={index} className="hover:bg-gray-50">
                                                                <td className="border px-4 py-2">{item.month}</td>
                                                                <td className="border px-4 py-2">{item.year}</td>
                                                                <td className="border px-4 py-2">{item.points_earned}</td>
                                                                <td className="border px-4 py-2">{item.points_reserved}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-gray-500">No data available</div>
                                        )}

                                    </div>
                                </div>
                            </ModalComponent>
                        )}




                    </div>
                </div>
            </div>
        </>
    );
};

export default MonthWisePointSummary;
